import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AdminPage from './pages/AdminPage';
import LegalPlaceholderPage from './pages/LegalPlaceholderPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route
          path="/mentions-legales"
          element={<LegalPlaceholderPage title="Mentions légales" />}
        />
        <Route
          path="/confidentialite"
          element={<LegalPlaceholderPage title="Politique de confidentialité" />}
        />
        <Route path="/cgv" element={<LegalPlaceholderPage title="CGV / CGU" />} />
      </Routes>
    </BrowserRouter>
  );
}
